module.exports = __webpack_public_path__ + "img/file------------------@1x.f9770eec.png";